import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CREDIT_COSTS } from '../../../config/credits';

/**
 * Confirm-before-generate modal for the onboarding "Generate report" action. Presentational:
 * emits `confirm`; the host (DashboardTopLeadsComponent) performs the actual enhance call,
 * since generating consumes credits (spec-parity with unlock-email-confirm-modal).
 */
@Component({
  selector: 'app-generate-report-confirm-modal',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" (click)="closed.emit()">
      <div class="w-full max-w-sm rounded-xl bg-white p-6 shadow-xl dark:bg-gray-800" (click)="$event.stopPropagation()">

        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-blue-50 mb-4">
          <svg class="w-6 h-6 text-blue-royal" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
          </svg>
        </div>

        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Generate report</h2>
        <p class="mt-2 text-sm text-gray-600 dark:text-gray-300">
          Generating a full report for <strong>{{ leadName }}</strong> uses <strong>{{ cost }} credits</strong>.
          Do you want to continue?
        </p>

        <div class="mt-6 flex justify-end gap-2">
          <button type="button"
                  class="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600"
                  (click)="closed.emit()">
            Cancel
          </button>
          <button type="button"
                  class="px-4 py-2 text-sm font-medium text-white bg-indigo-600 rounded-lg hover:bg-indigo-500"
                  (click)="confirm.emit()">
            Generate report
          </button>
        </div>

      </div>
    </div>
  `
})
export class GenerateReportConfirmModalComponent {
  @Input() leadName = '';
  readonly cost = CREDIT_COSTS.daily_leads_enhanced_report;

  @Output() confirm = new EventEmitter<void>();
  @Output() closed = new EventEmitter<void>();

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.closed.emit();
  }
}
